import React from 'react';

import { type AdControlContextValue } from '../../types';
import { AdControlContext } from '../main';

export function useAdControlContext(): AdControlContextValue {
	return React.useContext(AdControlContext);
}
